<template>
  <div class="content">
    <van-tabs v-model="active" sticky v-if="total">
      <van-tab title="理赔中">
        <div v-if="list1 && list1.length > 0">
          <van-cell
            class="cell"
            v-for="item in list1"
            :key="item.id"
            :title="item.id"
            @click="toDetail(item)"
          >
            <template #title>
              <div class="item item-time">
                <span class="item-title item-time-title"
                  >申请时间：{{ item.createTime }}</span
                >
                <span class="status">理赔中</span>
              </div>
              <div class="bx-name">{{ item.productName }}</div>
              <div class="item name">
                <span class="item-title">保单号：</span>
                <span class="item-content">{{ item.policyNo }}</span>
              </div>
              <div class="item">
                <span class="item-title">出险人：</span>
                <span class="item-content">{{ item.insurederName }}</span>
              </div>
            </template>
          </van-cell>
        </div>
        <div v-else class="no-data-text no-text">暂无理赔中记录</div>
      </van-tab>
      <van-tab title="已结案">
        <div v-if="list2 && list2.length > 0">
          <van-cell
            class="cell"
            v-for="item in list2"
            :key="item.id"
            :title="item.id"
            @click="toDetail(item)"
          >
            <template #title>
              <div class="item item-time">
                <span class="item-title item-time-title"
                  >申请时间：{{ item.createTime }}</span
                >
                <span class="status" :class="{ error: !item.claimsResult }">{{
                  item.claimsResult ? "理赔成功" : "理赔失败"
                }}</span>
              </div>
              <div class="bx-name">{{ item.productName }}</div>
              <div class="item name">
                <span class="item-title">保单号：</span>
                <span class="item-content">{{ item.policyNo }}</span>
              </div>
              <div class="item">
                <span class="item-title">出险人：</span>
                <span class="item-content">{{ item.insurederName }}</span>
              </div>
              <div
                class="error-info"
                v-if="item.resultDescribe && !item.claimsResult"
              >
                {{ item.resultDescribe }}
              </div>
            </template>
          </van-cell>
        </div>
        <div v-else class="no-data-text no-text">暂无已结案记录</div>
      </van-tab>
    </van-tabs>
    <div class="no-data-box" v-else>
      <img
        class="no-data"
        src="../../static/images/applyInfo/no-data.png"
        alt=""
      />
      <div class="no-data-text">暂无理赔记录</div>
    </div>
  </div>
</template>

<script>
import { loading } from "@/api/mixins";
export default {
  mixins: [loading],
  data() {
    return {
      active: 0,
      total: 1,
      list1: [],
      list2: [],
    };
  },
  created() {
    this.loading = true;
    this.active = this.$route.query.id - 1;
    this.getAllList();
  },
  mounted() {
    this.$weixin.hideMenu();
  },
  methods: {
    getAllList() {
      Promise.all([this.getList("0,2"), this.getList("1")])
        .then(([data, result]) => {
          this.loading = false;
          if (data.data) {
            this.list1 = data.data;
          }
          if (result.data) {
            this.list2 = result.data;
          }
          if (data.data && result.data) {
            this.total = this.list1.length + this.list2.length;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.total = 0;
        });
    },
    getList(type) {
      return this.$http({
        type: "PUT",
        url: "/api/compensation/getCompensations",
        data: {
          settleStatus: type,
          mechanCode: this.$route.query.code,
        },
      });
    },
    toDetail(item) {
      this.$router.push({
        name: "applyInfo.detail",
        query: {
          id: item.id,
          plat: item.plat,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 100%;
  background: #f5f7fa;
  .item {
    display: flex;
    .item-title {
      font-weight: 400;
      font-size: 28px;
      color: #888888;
    }
    .item-content {
      font-size: 28px;
      font-weight: 400;
      color: #3c464f;
    }
  }
  .item-time {
    height: 70px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    .item-time-title {
      font-size: 24px;
    }
    .status {
      font-size: 28px;
      font-weight: 400;
      color: #236dff;
      opacity: 1;
    }
    .error {
      color: #dd2f00;
    }
  }
  .bx-name {
    font-size: 32px;
    font-weight: 500;
    color: #3c464f;
    margin: 20px 0;
  }
  .name {
    margin-bottom: 10px;
  }
  .error-info {
    display: flex;
    align-items: center;
    height: 90px;
    background: #f9fafb;
    opacity: 1;
    border-radius: 10px;
    padding-left: 30px;
    font-size: 28px;
    color: #dd2f00;
    margin-top: 30px;
  }
}
.no-data-box {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #fff;
  margin-top: 20px;
  padding-top: 140px;
  img {
    display: block;
    width: 490px;
    height: 282px;
    margin: 0 auto;
  }
}
.no-data-text {
  text-align: center;
  margin-top: 20px;
  color: #727c8e;
  font-size: 30px;
  font-weight: 400;
}
.no-text {
  margin-top: 100px;
}
/deep/ .van-tabs {
  border-bottom: none;
}
/deep/ .cell {
  width: 690px;
  background-color: #fff;
  border-radius: 10px;
  padding: 0 30px 25px;
  margin: 20px 30px 0;
}
/deep/ .van-tabs .van-tabs__nav .van-tab {
  margin-right: 0;
  width: 50%;
}
</style>